// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"71267f45","216":"a9ab7334","453":"03346f77","553":"48a2ec8a","828":"9a8dbd91","852":"da7c08bd","996":"29d40e96"}[chunkId] + ".chunk.js";
};